import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.jpeg";

const navLinks = [
  { label: "Home", href: "/", type: "link" },
  { label: "Services", href: "/services", type: "link" },
  { label: "About", href: "/about", type: "link" },
  { label: "Contact", href: "/#contact", type: "anchor" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-md border-b border-border">
      <div className="container mx-auto flex items-center justify-between h-14 md:h-16 px-4">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Graphic Lines logo" className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover" />
          <span className="font-display font-bold text-lg md:text-xl text-foreground">
            Graphic <span className="text-primary">Lines</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) =>
            link.type === "link" ? (
              <Link key={link.label} to={link.href} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors duration-200">
                {link.label}
              </Link>
            ) : (
              <a key={link.label} href={link.href} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors duration-200">
                {link.label}
              </a>
            )
          )}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a href="https://wa.me/+923058559591" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm font-medium text-foreground">
            <Phone className="w-4 h-4 text-primary" />
            +92 3058559591
          </a>
        </div>

        <button className="lg:hidden p-2 text-foreground" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background border-b border-border px-4 pb-4">
          {navLinks.map((link) =>
            link.type === "link" ? (
              <Link key={link.label} to={link.href} className="block py-2 text-sm font-medium text-muted-foreground hover:text-primary" onClick={() => setOpen(false)}>
                {link.label}
              </Link>
            ) : (
              <a key={link.label} href={link.href} className="block py-2 text-sm font-medium text-muted-foreground hover:text-primary" onClick={() => setOpen(false)}>
                {link.label}
              </a>
            )
          )}
          <a href="https://wa.me/+923058559591" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 py-2 text-sm font-medium text-primary">
            <Phone className="w-4 h-4" />
            +92 3058559591
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
